export const utf8Length = (value: string) =>
  new TextEncoder().encode(value).length;

export function validatePassword(password: string, creating = false): void {
  const bytes = utf8Length(password);
  if (bytes > 1024 || (creating ? bytes < 12 : bytes === 0)) {
    throw new Error(
      creating
        ? 'Password must be 12–1024 UTF-8 bytes.'
        : 'Enter a password of at most 1024 UTF-8 bytes.'
    );
  }
}

export function validateCredentials(
  username: string,
  password: string,
  name?: string
): void {
  if (!/^[A-Za-z0-9._-]{3,64}$/.test(username)) {
    throw new Error(
      'Username must contain 3–64 letters, numbers, dots, underscores or hyphens.'
    );
  }
  validatePassword(password, name !== undefined);
  if (name !== undefined && (!name.trim() || utf8Length(name) > 128)) {
    throw new Error('Name is required and must be at most 128 UTF-8 bytes.');
  }
}
export function validateProfileText(
  value: string,
  label: string,
  maxBytes: number,
  required = false
) {
  if (
    (!value.trim() && required) ||
    (value !== '' &&
      (!value.trim() ||
        Array.from(value).some((character) => {
          const code = character.charCodeAt(0);
          return code < 32 || (code >= 127 && code <= 159);
        }))) ||
    utf8Length(value) > maxBytes
  ) {
    throw new Error(
      `${label} must contain valid text of at most ${maxBytes} UTF-8 bytes.`
    );
  }
}
export function validatePersonalInfo(
  name: string,
  github: string,
  portfolio: string
) {
  validateProfileText(name, 'Name', 128, true);
  if (
    github &&
    !/^[A-Za-z0-9](?:[A-Za-z0-9-]{0,37}[A-Za-z0-9])?$/.test(github)
  ) {
    throw new Error(
      'Enter a valid GitHub username (1–39 letters, numbers or internal hyphens).'
    );
  }
  validateProfileUrl(portfolio, 'Portfolio');
}
export function validateProfileUrl(value: string, label: string) {
  if (!value) return;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    throw new Error(`${label} must be a complete http:// or https:// URL.`);
  }
  if (
    !['http:', 'https:'].includes(url.protocol) ||
    !url.hostname ||
    url.username ||
    url.password ||
    utf8Length(value) > 2048
  ) {
    throw new Error(
      `${label} must be an HTTP(S) URL without credentials, at most 2048 UTF-8 bytes.`
    );
  }
}

export function validateImage(file: File) {
  if (
    !['image/png', 'image/jpeg', 'image/webp'].includes(file.type) ||
    file.size === 0 ||
    file.size > 1024 * 1024
  ) {
    throw new Error('Choose a PNG, JPEG or WebP image no larger than 1 MiB.');
  }
}
export function weeklyMinutes(hours: number) {
  if (!Number.isInteger(hours) || hours < 0 || hours > 168)
    throw new Error('Weekly hours must be a whole number from 0 to 168.');
  return hours * 60;
}

export function validateContactEmail(email: string): void {
  validateProfileText(email, 'Contact email', 254, true);
  if (!/^[^\s@]+@[^\s@]+$/.test(email)) {
    throw new Error('Enter a valid contact email.');
  }
}
